import React, { Component } from 'react';
import moment from 'moment';
import AppointmentTypeDropdown from './components/AppointmentTypeDropdown';
import AppointmentTypeSelect from './components/AppointmentTypeSelect';
import CustomCalendar from './components/CustomCalendar';
import CalendarToggler from './components/CalendarToggler';
import ErrorMessages from './components/ErrorMessages';
import { Row, Col, Input, Label } from 'reactstrap';
import LocationSelect from './components/LocationSelect';


class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.locationMap = [
      {name: 'Berlin', practiceId: 'pqsnx8bnda96b34g', eventCategoryId: '51301'},
      {name: 'Hamburg', practiceId: '7yhhhdcdtdc98jfy', eventCategoryId: '65835'},
      {name: 'Köln', practiceId: 'c102tef3br01mjbd', eventCategoryId: '69422'},
      {name: 'Düsseldorf', practiceId: '5t9366asm4jpa5ht', eventCategoryId: '69415'},
      {name: 'München', practiceId: '59q42en6n472q2jd', eventCategoryId: '73072'},
      {name: 'Stuttgart', practiceId: '0v42def8gvqkhtpx', eventCategoryId: '73156'},
      {name: 'Rostock', practiceId: '8rcgf9e6a2qrcnxx', eventCategoryId: '79598'},
      {name: 'Frankfurt am Main', practiceId: 'c7jsrxaqa038517v', eventCategoryId: '79566'},
    ];

    this.state = {
      bookingCompleted: false,
      availableEventTypes: [],
      availableDates: [],
      availableTimes: [],

      currentWeek: {
        from: moment().isoWeekday(1),
        to: moment().isoWeekday(7)
      },
      calendarLoaded: false,

      eventCategoryId: null,
      appointmentType: {value: null, label: null},
      location: {value: null, label: null},
      selectedTimeslot: null,
      firstname: null,
      lastname: null,
      ort: null,
      postleitzahl: null,
      strasse: null,
      hausnummer: null,
      email: null,
      phone: null,
      checkNotifications: null,
      checkOptin: null,
      checkAGB: null,

      validation: {
        location: true,
        email: true,
        phone: true,
        lastname: true,
        firstname: true,
        checkOptin: true,
        checkAGB: true,
        appointmentType: true,
        selectedTimeslot: true,
        ort: true,
        postleitzahl: true,
        strasse: true,
        hausnummer: true,

      },

      customValidator: {
        location: (val) => { return val && val.value },
        selectedTimeslot: (val) => { return val && val.hasOwnProperty("time") },
        appointmentType: (val) => { return val && val.value }
      }
    };

    this.handleAppointmentTypeChange = this.handleAppointmentTypeChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePrevWeek = this.handlePrevWeek.bind(this);
    this.handleNextWeek = this.handleNextWeek.bind(this);
    this.handleSimpleInput = this.handleSimpleInput.bind(this);
    this.handleCheckboxInput = this.handleCheckboxInput.bind(this);
    this.handleTimeslotSelected = this.handleTimeslotSelected.bind(this);
  }

  componentDidMount() {
    //this.fetchEventTypes();
  }

  fetchEventTypes(eventCategoryId) {
    const endpoint = `/api/booking/v3/event_types?event_category_id=${eventCategoryId}&client_id=${this.props.clientId}`;
    fetch(endpoint).then(response => {
      return response.json();
    }).then(data => {
      this.setState({
        availableEventTypes: data.data
      })
    });
  }

  fetchAvailableDatesAndTimes(forAppointmentId, from, to) {
    this.setState({calendarLoaded: false});

    const endpoint = `/api/booking/v3/dates?event_category_id=${this.state.eventCategoryId}`
      + `&event_type_id=${forAppointmentId}`
      + `&from=${from.format('YYYY-MM-DD')}`
      + `&to=${to.format('YYYY-MM-DD')}`
      + `&client_id=${this.props.clientId}`;

    fetch(endpoint).then(response => {
      return response.json();
    }).then(data => {
      const availableDaysForAWeek = data.data.filter((item) => {
        const date = moment(item.date);
        if (date.isSameOrAfter(from, 'day') && date.isSameOrBefore(to, 'day')) {
          return true;
        }
        return false;
      });
      this.setState({availableDates: availableDaysForAWeek});

    }).then(() => {
      const endpoint = `/api/booking/v3/times?event_category_id=${this.state.eventCategoryId}`
        + `&event_type_id=${forAppointmentId}`
        + `&from=${from.format('YYYY-MM-DD')}`
        + `&to=${to.format('YYYY-MM-DD')}`
        + `&client_id=${this.props.clientId}`;

      fetch(endpoint).then(response => {
        return response.json();
      }).then(data => {
        this.setState({
          calendarLoaded: true,
          availableTimes: data.data
        });
      })
    });
  }

  handleLocationChange(newLocation) {
    this.setState({
      location: newLocation,
      eventCategoryId: newLocation.value,
      validation: { ...this.state.validation, location: true},
      appointmentType: {value: null, label: null},
      availableDates: [],
      availableTimes: [],
    });

    this.fetchEventTypes(newLocation.value);
  }

  handleAppointmentTypeChange(newAppointment) {
    if (newAppointment == null) {
      this.setState({
        appointmentType: {value: null, label: null},
        availableDates: [],
        availableTimes: [],
      });

      return;
    }

    this.setState({
      appointmentType: newAppointment,
      validation: { ...this.state.validation, appointmentType: true}
    });
    this.fetchAvailableDatesAndTimes(
      newAppointment.value,
      moment().isoWeekday(1),
      moment().isoWeekday(7)
    );
  }

  handlePrevWeek(e) {
    const prevWeekFrom = moment(this.state.currentWeek.from).subtract(1, 'weeks');
    const prevWeekTo = moment(this.state.currentWeek.to).subtract(1, 'weeks');

    this.setState({
      currentWeek: {from: prevWeekFrom, to: prevWeekTo}
    });
    this.fetchAvailableDatesAndTimes(this.state.appointmentType.value, prevWeekFrom, prevWeekTo);
  }

  handleNextWeek(e) {
    const nextWeekFrom = moment(this.state.currentWeek.from).add(1, 'weeks');
    const nextWeekTo = moment(this.state.currentWeek.to).add(1, 'weeks');

    this.setState({
      currentWeek: {from: nextWeekFrom, to: nextWeekTo}
    });
    this.fetchAvailableDatesAndTimes(this.state.appointmentType.value, nextWeekFrom, nextWeekTo);
  }

  handleSimpleInput(e) {
    let validation = {...this.state.validation};
    validation[e.target.name] = true;
    this.setState({
      [e.target.name]: e.target.value,
      validation: validation
    });
  }

  handleCheckboxInput(e) {
    let validation = {...this.state.validation};
    if (e.target.name == 'checkOptin') {
      validation[e.target.name] = true;
    }

    if (e.target.name == 'checkAGB') {
      validation[e.target.name] = true;
    }

    this.setState({
      [e.target.name]: e.target.checked,
      validation: validation
    });
  }

  handleTimeslotSelected(timeslot) {
    this.setState({
      selectedTimeslot: timeslot,
      validation: { ...this.state.validation, selectedTimeslot: true}
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!this.validate()) {
      return;
    }

    console.log("booking...");
    this.book();
  }

  validate() {
    //const validateableFields = Object.keys(this.state.validation).map(i => this.state.validation[i])
    let isValid = true;
    const validatedFields = {};
    Object.keys(this.state.validation).forEach(key => {
      if (key in this.state.customValidator) {
        if (!this.state.customValidator[key](this.state[key])) {
          validatedFields[key] = false;
          isValid = false;
          return;
        }
      } else if (this.state[key] == null || !this.state[key]) {
        validatedFields[key] = false;
        isValid = false;
        return;
      }

      validatedFields[key] = true;
    });

    this.setState({
      validation: validatedFields
    });

    return isValid;
  }

  book() {
    const endpoint = `/api/booking/v3/book`;
    const dataToSubmit = {
      "client_id": this.props.clientId,
      "event_category_id": this.state.eventCategoryId,
      "event_type_id": this.state.appointmentType.value,
      "starts_at": this.state.selectedTimeslot.time,
      "token": this.state.selectedTimeslot.token,
      "do_notification": this.state.checkNotifications,
      "attendant[data][first_name]": this.state.firstname,
      "attendant[data][last_name]": this.state.lastname,
      "attendant[data][email]": this.state.email,
      "attendant[data][phone]": this.state.phone,
      "attendant[data][mobile]": this.state.phone,

      "attendant[data][street]": this.state.strasse + ' ' + this.state.hausnummer,
      "attendant[data][city]": this.state.ort,
      "attendant[data][zip]": this.state.postleitzahl
    }
    let formBody = [];
    for (var property in dataToSubmit) {
      var encodedKey = property; /*encodeURIComponent(property);*/
      var encodedValue = encodeURIComponent(dataToSubmit[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    console.log(formBody);


    fetch(endpoint, {
      method: 'POST',
      body: formBody,
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded"
      })
    }).then(res => {
      if (res.ok) {
        this.props.onSuccess(this.state.selectedTimeslot, this.state.appointmentType, this.state.location.label);
      } else {
        throw new Error("Request was not successfull");
      }
    }).catch(error => {
      console.error('Error:', error)
    });


  }


  render() {
    return (
        <div>
          <form name="appointment-form" onSubmit={this.handleSubmit}>
            <Row>
              <Col className={"form-col" + (!this.state.validation.location ? " invalid" : "") }>
                <LocationSelect
                  name="practice"
                  onChange={this.handleLocationChange}
                  selectedOption={this.state.location}
                  availablePractices={this.locationMap}
                  placeholder="Bitte Standort wählen"
                />
              </Col>
            </Row>

            <Row>
              <Col className={"form-col" + (!this.state.validation.appointmentType ? " invalid" : "") }>
                <AppointmentTypeSelect
                  name="some-name"
                  onChange={this.handleAppointmentTypeChange}
                  selectedOption={this.state.appointmentType}
                  availableEventTypes={this.state.availableEventTypes}
                  placeholder="Bitte Terminart wählen"
                />
              </Col>
            </Row>

            <Row>
              <Col className={"form-col" + (!this.state.validation.selectedTimeslot ? " invalid" : "") } >
                <CalendarToggler
                  availableDates={this.state.availableDates}
                  availableTimes={this.state.availableTimes}
                  currentWeek={this.state.currentWeek}
                  calendarLoaded={this.state.calendarLoaded}
                  prevWeek={this.handlePrevWeek}
                  nextWeek={this.handleNextWeek}
                  onTimeslotSelected={this.handleTimeslotSelected}
                  disabled={ (this.state.appointmentType.value == null) ? true : false }
                />
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6} className={"form-col" + (!this.state.validation.firstname ? " invalid" : "") }>
                <div>
                  <div><label>Vorname*</label></div>
                </div>
                <div>
                  <Input
                    type="text"
                    name="firstname"
                    placeholder="Bitte Vorname eingeben"
                    value={this.state.firstname}
                    className={ (this.state.firstname ? "has-value" : "") }
                    onChange={this.handleSimpleInput}
                    />
                </div>
              </Col>
              <Col xs={12} md={6} className={"form-col" + (!this.state.validation.lastname ? " invalid" : "") }>
                <div>
                  <div><label>Nachname*</label></div>
                </div>
                <div>
                  <Input
                    type="text"
                    name="lastname"
                    placeholder="Bitte Nachname eingeben"
                    value={this.state.lastname}
                    className={ (this.state.lastname) ? "has-value" : "" }
                    onChange={this.handleSimpleInput}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6} className={"form-col" + (!this.state.validation.ort ? " invalid" : "") }>
                <div>
                  <div><label>Ort*</label></div>
                </div>
                <div>
                  <Input
                    type="text"
                    name="ort"
                    placeholder="Bitte Ort eingeben"
                    value={this.state.ort}
                    className={ (this.state.ort ? "has-value" : "") }
                    onChange={this.handleSimpleInput}
                    />
                </div>
              </Col>
              <Col xs={12} md={6} className={"form-col" + (!this.state.validation.postleitzahl ? " invalid" : "") }>
                <div>
                  <div><label>Postleitzahl*</label></div>
                </div>
                <div>
                  <Input
                    type="text"
                    name="postleitzahl"
                    placeholder="Bitte Postleitzahl eingeben"
                    value={this.state.postleitzahl}
                    className={ (this.state.postleitzahl) ? "has-value" : "" }
                    onChange={this.handleSimpleInput}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6} className={"form-col" + (!this.state.validation.strasse ? " invalid" : "") }>
                <div>
                  <div><label>Straße*</label></div>
                </div>
                <div>
                  <Input
                    type="text"
                    name="strasse"
                    placeholder="Bitte Straße eingeben"
                    value={this.state.strasse}
                    className={ (this.state.strasse ? "has-value" : "") }
                    onChange={this.handleSimpleInput}
                    />
                </div>
              </Col>
              <Col xs={12} md={6} className={"form-col" + (!this.state.validation.hausnummer ? " invalid" : "") }>
                <div>
                  <div><label>Hausnummer*</label></div>
                </div>
                <div>
                  <Input
                    type="text"
                    name="hausnummer"
                    placeholder="Bitte Hausnummer eingeben"
                    value={this.state.hausnummer}
                    className={ (this.state.hausnummer) ? "has-value" : "" }
                    onChange={this.handleSimpleInput}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6} className={"form-col" + (!this.state.validation.phone ? " invalid" : "") }>
                <div>
                  <div><label>Mobilfunknummer*</label></div>
                </div>
                <div>
                  <Input
                    type="text"
                    name="phone"
                    placeholder="Bitte Nummer eingeben"
                    value={this.state.phone}
                    className={ this.state.phone ? "has-value" : "" }
                    onChange={this.handleSimpleInput}
                  />
                </div>
              </Col>
              <Col xs={12} md={6} className={"form-col" + (!this.state.validation.email ? " invalid" : "") }>
                <div>
                  <div><label>E-mail*</label></div>
                </div>
                <div>
                  <Input
                    type="text"
                    name="email"
                    placeholder="Bitte E-Mail eingeben"
                    value={this.state.email}
                    className={ this.state.email ? "has-value" : "" }
                    onChange={this.handleSimpleInput}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col className="form-col taxi-checkbox-wrapper">
                <input type="checkbox" id="checkNotifications" name="checkNotifications" checked={this.state.checkNotifications} onChange={this.handleCheckboxInput} />
                <label for="checkNotifications">
                  <span></span>
                  Taxiarzt.de darf mir Benachrichtigungen/Mitteilungen zu diesem Termin schicken.
                </label>
              </Col>
            </Row>
            <Row>
              <Col className={"form-col taxi-checkbox-wrapper" + (!this.state.validation.checkOptin ? " invalid" : "")}>
                <input type="checkbox" id="checkOptin" name="checkOptin" checked={this.state.checkOptin} onChange={this.handleCheckboxInput} />
                <label for="checkOptin">
                  <span></span>
                  * Ich stimme zu, dass meine persönlichen Daten an Taxiarzt.de weitergegeben werden.
                </label>
              </Col>
            </Row>
            <Row>
              <Col className={"form-col taxi-checkbox-wrapper" + (!this.state.validation.checkAGB ? " invalid" : "")}>
                <input type="checkbox" id="checkAGB" name="checkAGB" checked={this.state.checkAGB} onChange={this.handleCheckboxInput} />
                <label for="checkAGB">
                  <span></span>
                  * Ich akzeptiere die <a href="https://www.taxiarzt.de/agb" target='_blank'>AGBs</a>.
                </label>
              </Col>
            </Row>
            <ErrorMessages validation={this.state.validation} />

            <Row>
              <Col className="form-col">
                <input className="taxi-cta" type="submit" value="Jetzt Buchen" />
              </Col>
            </Row>

          </form>

        </div>
    );
  }

  renderSuccess() {
    return (
      <div><h3>Success!</h3></div>
    )
  }
}

function findClosestMonday() {
  return moment().isoWeekday(1);
}

export default RegistrationForm;




// WEBPACK FOOTER //
// ./src/RegistrationForm.js